import { createSlice } from "@reduxjs/toolkit";
import CommonListKeys from "../../../constants/common-list-keys";
import Types from "../../../constants/types";

const initialState = {
  GPSLocation: false,
  IPAddress: false,
  landingPageData: null,
  titleList: [],
  branchesList: [],
  relationshipList: [],
  membershipCardTypeList: [],
  countryCodeList: [],
  provinceList: [],
  countryList: [],
  bankList: [],
  socialLogin: {
    socialLoginType: null,
    socialLoginID: null,
    requestBody: null,
    socialLoginResponse: null,
    isShowOTPScreen: false,
  },
};

const landingPageReducer = createSlice({
  name: "LandingPageReducer",
  initialState: initialState,
  reducers: {
    setLandingPageData: (state, { payload }) => {
      state.landingPageData = payload;
    },
    setGPSData: (state, { payload }) => {
      state.GPSLocation = payload;
    },
    setIPAddress: (state, { payload }) => {
      state.IPAddress = payload;
    },
    setCommonListData: (state, { payload }) => {
      state.titleList = payload.find((val) => val.Type === CommonListKeys.TITLE).data ?? [];
      state.branchesList = payload.find((val) => val.Type === CommonListKeys.BRANCHES).data ?? [];
      state.relationshipList = payload.find((val) => val.Type === CommonListKeys.RELATIONSHIP).data ?? [];
      state.membershipCardTypeList = payload.find((val) => val.Type === CommonListKeys.MEMBERSHIP_CARD_TYPE).data ?? [];
    },
    setCountryCodeList: (state, { payload }) => {
      state.countryCodeList = payload;
    },
    setSocialLogin: (state, { payload }) => {
      state.socialLogin = payload;
    },
    setCommonData: (state, { payload }) => {
      state.provinceList = payload.find((val) => val.Request === Types.PROVINCE).Values ?? [];
      state.countryList = payload.find((val) => val.Request === Types.COUNTRY).Values ?? [];
      state.bankList = payload.find((val) => val.Request === Types.BANK).Values ?? [];
    },
  },
});

export default landingPageReducer;
